import React from 'react';
import { Link } from 'react-router-dom';
import Quote from './Quote';
import { useGetQuotesQuery, useDeleteQuoteMutation ,selectAllQuotes } from './quotesApiSlice';
import { useSelector } from 'react-redux';

const QuoteList = () => {
  const { isLoading, isError, error, isSuccess } = useGetQuotesQuery();

  const quotes = useSelector(selectAllQuotes); // ✅ correct way for entityAdapter
  
  const [deleteQuote] = useDeleteQuoteMutation();

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this quote?")) {
      await deleteQuote({ id });
    }
  };
  if (isLoading) return <p>Loading...</p>;
  if (isError) return <p>Error: {error?.data?.message}</p>;

  return (
    <div>
      <h2>Quotes</h2>
      <Link to="/dashboard/quotes/new" className="btn btn-primary mb-3">Add New Quote</Link>
      {isLoading ? <p>Loading...</p> :
        isError ? <p>Error loading quotes.</p> :
        <table className="table table-bordered">
          <thead>
            <tr>
              <th>Text</th>
              <th>Author</th>
              <th>Language</th>
              <th>Category</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {quotes.map(q => <Quote key={q._id} quote={q} onDelete={handleDelete} />)}
          </tbody>
        </table>}
    </div>
  );
};

export default QuoteList;